module.exports = __webpack_public_path__ + "static/media/studio-slide6.c2bba3af.png";